/**
 * menuRenderUtils.jsx
 * Utility functions for rendering menu items and dropdowns using Calcite components.
 */

import "@esri/calcite-components/components/calcite-menu-item";
import "@esri/calcite-components/components/calcite-dropdown";
import "@esri/calcite-components/components/calcite-button";
import "@esri/calcite-components/components/calcite-dropdown-group";
import "@esri/calcite-components/components/calcite-dropdown-item";

import { prefetchComponent } from '@cores/layouts/utils/prefetchUtils';

const handleMouseEnter = (key, config) => {
  if (config.prefetch) {
    prefetchComponent(config.prefetch);
  }
};

// Added currentPath to support active menu highlighting
export function renderMenuItem(
  key,
  config,
  handleMenuItemClickWithState,
  setDropdownTaskBar,
  currentPath
) {
  const isActive = currentPath === config.path;

  if (config.dropdownItems) {
    return (
      <calcite-dropdown
        key={key}
        width="auto"
        aria-label={`${config.text} dropdown`}
      >
        <calcite-button
          slot="trigger"
          icon-start={config.icon}
          aria-label={config.text}
          onClick={() => {
            handleMenuItemClickWithState(
              key,
              true
            );
          }}
          onMouseEnter={() =>
            handleMouseEnter(key, config)
          }
          appearance="transparent"
          kind="neutral"
        >
          {config.text}
        </calcite-button>

        <calcite-dropdown-group
          selection-mode="none"
        >
          {config.dropdownItems.map(
            (item, index) => (
              <calcite-dropdown-item
                key={`${key}-${index}`}
                icon-start={item.icon}
                aria-label={item.text}
                oncalcitedropdownitemselect={() => {
                  if (
                    item.dropdownItemTaskItems
                  ) {
                    setDropdownTaskBar(
                      item.dropdownItemTaskItems
                    );
                  }

                  // If desired:
                  // handleMenuItemClickWithState(
                  //   item.action,
                  //   false,
                  //   item,
                  //   key
                  // );
                }}
              >
                {item.text}
              </calcite-dropdown-item>
            )
          )}
        </calcite-dropdown-group>
      </calcite-dropdown>
    );
  }

  return (
    <calcite-menu-item
      key={key}
      text={config.text}
      icon-start={config.icon}
      aria-label={config.text}
      active={isActive}
      onMouseEnter={() =>
        handleMouseEnter(key, config)
      }
      onClick={() => {
        handleMenuItemClickWithState(
          key,
          true
        );
      }}
    />
  );
}